import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ui-lightning-modal-header',
  templateUrl: './modal-header.component.html',
  styleUrls: ['./modal-header.component.css']
})
export class ModalHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
